import { withTranslation } from "next-i18next";
import { useRouter } from "next/router";
import Button from "../Button";
import classNames from "classnames";

const SharedAccountsLayout = ({ className, title, t }) => {
  const router = useRouter();

  return (
    <div className={classNames("bg-white border-bottom", className)}>
      <div className="text-center">
        <div className="accounts-title-container">
          <Button
            title={t("common:back")}
            variant="ghost-dark"
            leftIconName="chevron-left"
            className="accounts-back-button"
            onClick={() => router.back()}
          />
          <h1 className="h4 mb-0 px-4">{t(`accounts:${title}`)}</h1>
          <div className="p-3 m-1" />
        </div>
      </div>
    </div>
  );
};

export default withTranslation(["accounts", "common"])(SharedAccountsLayout);
